import React, {useEffect, useState, useContext} from 'react'
import UserContext from '../context/UserContext'
import DictionaryContext from '../context/DictionaryContext'
import FormFields from './FormFields'
import styles from './InventoryForm.module.css'
import moment from 'moment'
import { Col } from 'react-bootstrap'
import { trackPromise } from 'react-promise-tracker'

function UserItem(props) {

    const fields = FormFields()
    const [itemAttestationStatus, setItemAttestionStatus] = useState(null)
    const userCtx = useContext(UserContext)
    const dictCtx = useContext(DictionaryContext)

    const currentYear = +new Date().getFullYear();

    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST

    const onClick = (e) => {
        e.preventDefault()
        props.onItemSelect(props.item)
    }

    // item style depanding on certification status (admin only)
    // uncertified, init-certified, final-certified
    const getItemStyle = () => {
        if (props.mode === 'admin') {
            // if (!!props.item.final_validation_by) {
            //     return 'final-certified'
            // } else 
            if (!!props.item.initial_validation_by && !!props.item.initial_validation_date &&  new Date(props.item.initial_validation_date) >= new Date(dictCtx.dict_certification_start_date)) {
                return 'final-certified'
            } else {
                return 'uncertified'
            }
        } else if (dictCtx.dict_attestion_status === 'ON') {
          if (!props.item.device_status) {
            return 'not-attested';
          } else {
            return 'attested';
          }

            // console.log("ITEM itemAttestationStatus, currentYear", itemAttestationStatus, currentYear)

            // use green for attested items, red for not attested and orange for errors (errors getting attestation status)
            // if (itemAttestationStatus === null || itemAttestationStatus.is_active === true && itemAttestationStatus?.record_added_year != currentYear) {
            //     return 'not-attested'
            // } else if (itemAttestationStatus.is_active === true && itemAttestationStatus?.record_added_year == currentYear) {
            //     return 'attested'
            // } else {
            //     return 'attestation-unknown'
            // }


            // if (props.item.inventory_attests !== null && props.item.inventory_attests.length > 0) {
            //     // find the latest active attestation 
            //     const active_attestation = props.item.inventory_attests.filter(att => !!att.is_active)?.sort((att1, att2) => att2.record_added_year - att1.record_added_year)[0]
            //     if (!!active_attestation) {
            //         if (active_attestation.is_active === false || (active_attestation.is_active === true && active_attestation?.record_added_year != currentYear)) {
            //             return 'not-attested'
            //         } else if (active_attestation.is_active === true && active_attestation?.record_added_year == currentYear) {
            //             return 'attested'
            //         }
            //     } 
            // } else if (moment.utc(props.item.created_at).toDate().getFullYear() == currentYear) {
            //     if (props.item.added_by_employee_acct.toLowerCase() == props.item.employee_acct.toLowerCase()) {
            //         return 'attested'
            //     } else {
            //         return 'not-attested'
            //     }
                
            // } else {
            //     return 'not-attested'
            // }



        } else {
            return 'non-admin'
        }
    }

    // console.log("ITEM", props.item)

    // for admit get Certification status and Attestion status 
    // for a regular user get only Attestion status
    // for either get Attestion status only when attestation period is ON 
    const getItemCertAndAttestStatus = () => {
        const status = {}
        if (props.mode === 'admin') {
            // make sure item certification date >= certification start date, otherwise ignore it - it's an old ceertification
            if (!!props.item.initial_validation_by && new Date(props.item.initial_validation_date) >= new Date(dictCtx.dict_certification_start_date)) {
                status.certification = `Certification by ${props.item.initial_validation_by} on ${moment.utc(new Date(props.item.initial_validation_date)).format('MM/DD/YYYY')}`
                status.certification_by = props.item.initial_validation_by
                status.certification_date = props.item.initial_validation_date
                status.certification_class = 'final-certified-text'
                // return 'init-certified'
            } else {
                status.certification = 'Not Certified'
                status.certification_by = ''
                status.certification_date = ''
                status.certification_class = 'uncertified-text'
                // return 'uncertified'
            }
        }

            // 2026-04-16 - attestation is being removed. Instead flag devices without device status
            // console.log("props.item.device_status", props.item.device_status)
            if (!props.item.device_status) {
              status.attestation = 'Missing Device Status'
              status.attestation_by = ''
              status.attestation_date = ''
              status.attestation_year = ''
              status.attestation_class = 'not-attested-text'
            } else {
              status.attestation = ''
              status.attestation_by = ''
              status.attestation_date = ''
              status.attestation_year = ''
              status.attestation_class = 'attested-text'
            }
            
        return status
    }


    const attestAndCertStatus = getItemCertAndAttestStatus()

    return (
        <div className={`${styles.relative} ${props.isSelected ? 'mass-certificaton-selected' : ''}`} id={props.id}>
            <div className={`${styles.absolute} ${styles[getItemStyle()]} `} onClick={onClick}></div>
            {/* <div className={`container row  p-1 m-3 gx-5`} > */}
            {props.mode === 'user' && attestAndCertStatus.attestation === 'Missing Device Status' && 
                <div className='row' >
                    <span className={`mx-auto w-95 mt-2 ${styles['item-not-attested']}`}>Please update device status and save changes!</span>
                </div>
            }

            {props.mode === 'admin' && 
                <div className='row' >
                    <Col md={4} className={`mt-3 mx-3 ${styles[attestAndCertStatus.certification_class]}`}>
                        {/* <h6 className={`mt-3 mx-3 ${styles[attestAndCertStatus.certification_class]}`}>{attestAndCertStatus.certification}</h6> */}
                        {attestAndCertStatus.certification}
                    </Col>
                    
                    <Col md={{span:4, offset: 3}} className='mt-3'>
                        Last updated on {moment.utc(props.item.updated_at).format('MM/DD/YYYY')}
                    </Col>
                </div>
            }
            {props.mode === 'admin' && !!attestAndCertStatus.attestation &&
                <div className='row' >
                    <h6 className={`mt-2 mx-3 ${styles[attestAndCertStatus.attestation_class]}`}>{attestAndCertStatus.attestation}</h6>
                </div>
            }

            
            <div className={`container-fluid row p-1 m-3 gx-1`} >
            {!!props.item && fields.map(f => {
                return (
                    f.show_in_list && ((props.mode === "admin") || (!!!f.admin_only && (props.mode === 'user' || dictCtx.dict_attestion_status === 'ON'))) ?
                    <Col key={f.name} xxl={3} xl={4} lg={6}  xs={12} className={`${styles.handle_overflow} `}>
                        <div key={f.name} >
                            <div className={`form-floating`}>
                                {(f.type === 'datetime-local' || f.type === 'date') &&
                                    <input 
                                        className={`form-control ${styles['no-border']}`} 
                                        placeholder={f.display_name} 
                                        id={`${f.name}_${props.unique_ix}`} 
                                        type={f.type} 
                                        readOnly
                                        defaultValue={moment.utc(props.item[f.name]).startOf('minute').format('YYYY-MM-DDTHH:mm') || ' '}
                                    />
                                }
                                {(f.type === 'text' || f.type === 'number') &&
                                    <input 
                                        className={`form-control ${styles['no-border']}`} 
                                        placeholder={f.display_name} 
                                        id={`${f.name}_${props.unique_ix}`} 
                                        type={f.type} 
                                        readOnly
                                        defaultValue={props.item[f.name] || ' '} 
                                        // ref={(el) => inputRefs.current[f.name] = el}
                                    />
                                }

                                {(f.type === 'checkbox') &&
                                    <input 
                                        className='form-control'
                                        placeholder={f.display_name}
                                        id={`${f.name}_${props.unique_ix}`} 
                                        type={f.type} 
                                        readOnly
                                        checked={props.item[f.name] ? props.item[f.name] : false} 
                                        // ref={(el) => inputRefs.current[f.name] = el}
                                    />
                                }


                                {f.type === 'dictionary' &&
                                    // <div className=' flex flex-wrap items-center mt-5'>
                                    <input
                                        className={`form-control ${styles['no-border']}`} 
                                        placeholder={f.display_name}
                                        name={f.name}
                                        id={`${f.name}_${props.unique_ix}`} 
                                        readOnly
                                        // ref={(el) => inputRefs.current[f.name] = el}
                                        value={props.item[f.name] || ' '}
                                    />
                                    // </div>
                                }
                                <label htmlFor={`${f.name}_${props.unique_ix}`}  
                                    //className={styles['label-readonly']}
                                    //</div>className={styles.field_header}
                                >{f.list_display_name ?? f.display_name}</label>
                            </div>
                            
                            
                        </div>
                    </Col>
                    :
                    null
                    
                )

            })}
            </div>
        </div>
    )
}

export default UserItem
